import { PageType } from './../types';
import { BI, PAGES } from '../constants';
import { ArticleType } from '@wix/answers-api';

export const mapArticleTypeToItemType = (
  articleType: ArticleType | undefined
): string => {
  if (articleType === undefined) {
    return '';
  }
  switch (articleType) {
    case ArticleType.FEATURE_REQUEST:
      return BI.ITEM_TYPES.FEATURE_REQUEST;
    case ArticleType.KNOWN_ISSUE:
      return BI.ITEM_TYPES.KNOWN_ISSUE;
    case ArticleType.ARTICLE:
      return BI.ITEM_TYPES.ARTICLE;
    default:
      return BI.ITEM_TYPES.ARTICLE;
  }
};

export const mapPageTypeToSourceName = (pageType: PageType): string => {
  switch (pageType) {
    case PAGES.SEARCH_RESULTS:
      return BI.SOURCE_NAMES.SEARCH_RESULTS;
    case PAGES.ROADMAP:
      return BI.SOURCE_NAMES.ROADMAP;
    case PAGES.CATEGORY:
      return BI.SOURCE_NAMES.CATEGORY;
    case PAGES.TICKET:
      return BI.SOURCE_NAMES.TICKET;
    case PAGES.HOMEPAGE:
      return BI.SOURCE_NAMES.HOME;
    case PAGES.PROFILE:
      return BI.SOURCE_NAMES.PROFILE;
    case PAGES.ARTICLE:
    default:
      return BI.SOURCE_NAMES.ARTICLE;
  }
};

export const mapArticleVersionNumberToLabel = (
  articleVersion?: number
): string | undefined => {
  if (articleVersion === undefined) {
    return undefined;
  }
  return articleVersion === 0 ? 'B' : 'A';
};

export const mapReferralUrlToSourceName = (
  referralUrl = '',
  locale: string
): string | undefined => {
  if (!referralUrl.startsWith(location.origin)) {
    return undefined;
  }
  let relativePath = referralUrl.replace(location.origin, '');

  if (
    relativePath === '' ||
    relativePath === '/' ||
    relativePath.endsWith(`/${locale}/`) ||
    relativePath.endsWith(`/${locale}`)
  ) {
    return BI.SOURCE_NAMES.HOME;
  }

  if (relativePath.startsWith(`/${locale}/`)) {
    relativePath = relativePath.replace(`/${locale}/`, '');
  }
  if (relativePath.startsWith('/')) {
    relativePath = relativePath.replace('/', '');
  }
  switch (true) {
    case relativePath.startsWith('articles/') ||
      relativePath.startsWith('article/'):
      return BI.SOURCE_NAMES.ARTICLE;
    case relativePath.startsWith('contact'):
      return BI.SOURCE_NAMES.CONTACT;
    case relativePath.startsWith('roadmap'):
      return BI.SOURCE_NAMES.ROADMAP;
    case relativePath.includes('search?'):
      return BI.SOURCE_NAMES.SEARCH_RESULTS;
    case relativePath.startsWith('ticket/'):
      return BI.SOURCE_NAMES.TICKET;
    case relativePath.startsWith('user/'):
      return BI.SOURCE_NAMES.PROFILE;
    case relativePath.split('/').length === 2:
      return BI.SOURCE_NAMES.CATEGORY;
    default:
      return undefined;
  }
};
